// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { LineHeader } from '../_components/ui';
import { Editor } from './_partials';
/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let AuthorCardModuleUi = class AuthorCardModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.author = null;
    }
    async fetchRelated() {
        try {
            const author = await this.relatedService.resolve(this.module.content.authorRelated);
            if (author.isPageActive) {
                this.author = author;
            }
            else {
                this.onError(new Error('Author page does not exist'));
            }
        }
        catch (error) {
            this.onError(error);
        }
    }
};
AuthorCardModuleUi = __decorate([
    Component({
        name: 'AuthorCardModuleUi',
        components: { Editor, LineHeader },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <div class="author-view">
      <LineHeader v-if="module.content.canShowHeader" class="mb-5 mb-md-6">{{ $t('modules.author.title') }}</LineHeader>

      <Editor v-if="author" :editor="author" :showAbout="module.content.showAbout" :isLazy="module.isLazyLoaded"
              nameTag="h1" class="author-view__author pb-md-6 border-bottom"/>

      <div v-if="!module.content.showAbout" class="row justify-content-center justify-content-lg-start">
        <div v-if="author" v-html="author.description" class="col-12 col-lg-8 my-5 my-md-6 fs-medium"/>
      </div>
    </div>
  `
    })
], AuthorCardModuleUi);
export { AuthorCardModuleUi };
export default AuthorCardModuleUi;
